import React from 'react';
import { useStyles } from './totp.styles';
import { Box, Button, Grid, SvgIcon, Typography } from '@material-ui/core';
import { ReactComponent as SuccessIcon } from '../../assets/icons/success.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icons/error.svg';
import verifiedIcon from '../../assets/icons/verified-icon.svg';
import unverifiedIcon from '../../assets/icons/unverified-icon.svg';
import { TextConstants } from 'constants/TextConstants';
import AppConstants from '../../constants/index';

const TOTP_STEPS_ID = AppConstants.USERS_CONSTANTS.TOTP_STEPS.IDS; 
interface MessageTOTPProps {
  title: string;
  id: typeof TOTP_STEPS_ID.ERROR | typeof TOTP_STEPS_ID.SUCCESS ; 
  onResendCode?: () => void;
  isSwitchOn?: boolean; // Added for switch state
}



const MessageTOTP: React.FC<MessageTOTPProps> = ({ title, id, onResendCode, isSwitchOn }) => {
 const classes = useStyles();
 const typeConfig = {
    [TOTP_STEPS_ID.SUCCESS]: {
      className: classes.successMessage,
      image: <SvgIcon component={SuccessIcon}  viewBox="0 0 360 240" className='image'/> ,
      subTitle: isSwitchOn ? TextConstants.OTP_VERIFICATION_SUCCESS : TextConstants.OTP_VERIFICATION_SUCCESS2,
      icon: <img src={verifiedIcon} alt="verified-icon" className='icon'/>
    },
    [TOTP_STEPS_ID.ERROR]: {
      className: classes.errorMessage,
      image:  <SvgIcon component={ErrorIcon}  viewBox="0 0 360 240" className='image'/> ,
      icon: <img src={unverifiedIcon} alt="verified-icon" className='icon' />,
      subTitle: (
        <>
          {TextConstants.OTP_VERIFICATION_ERROR}
          <Button
            color="primary"
            onClick={onResendCode} // Trigger the callback when clicked
            className="resendCode"
          >
            {TextConstants.RESEND_CODE}
          </Button>
        </>
      ),       
    },
  };

  const { className, subTitle, image, icon } = typeConfig[id];

  return (
    <Grid className={`${classes.messageContainer} ${className}`}>
      <Box display="flex" alignItems="center" >
       {icon}
        <Typography variant="h6" className="heading">
          {title}
        </Typography>
      </Box>
      <Typography variant="body1" className="subHeading">
        {subTitle}
      </Typography>
      <Box  mt={2}>
      {image}
      </Box>
    </Grid>
  );
};

export default MessageTOTP;

